export default __webpack_public_path__ + "assets/docs/Forly_Terms_of_use_of_the_platform_en.pdf";